import React from "react"

const AppleIcon = (props) => {
  return (

    <svg xmlns="http://www.w3.org/2000/svg" width="9.726" height="11.93" viewBox="0 0 9.726 11.93">
    <g id="applelogo." transform="translate(-2.104)">
      <g id="Group_1" data-name="Group 1" transform="translate(2.104)">
        <path id="Path_1" data-name="Path 1" d="M13.66,0h.085A2.555,2.555,0,0,1,13.1,1.925a1.994,1.994,0,0,1-1.756.824A2.478,2.478,0,0,1,12,.884,2.829,2.829,0,0,1,13.66,0Z" transform="translate(-6.501)" fill="#fff"/>
        <path id="Path_2" data-name="Path 2" d="M11.83,11.372V11.4a6.941,6.941,0,0,1-.993,1.915c-.379.521-.843,1.223-1.672,1.223-.716,0-1.192-.46-1.926-.473-.776-.013-1.2.385-1.913.485H5.084a2.162,2.162,0,0,1-1.248-.86A7.537,7.537,0,0,1,2.1,9.349V8.815a3.5,3.5,0,0,1,1.527-2.87,2.578,2.578,0,0,1,1.731-.4,4.354,4.354,0,0,1,.848.243,2.342,2.342,0,0,0,.848.254,2.035,2.035,0,0,0,.595-.182,3.659,3.659,0,0,1,1.913-.339,2.654,2.654,0,0,1,1.95,1.163,2.5,2.5,0,0,0-1.271,2.483A2.564,2.564,0,0,0,11.83,11.372Z" transform="translate(-2.104 -2.615)" fill="#fff"/>
      </g>
    </g>
  </svg>

  )
}

export default AppleIcon
